<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between">
  <div class="flex justify-content-start">
    <app-new-order-dialog></app-new-order-dialog>
    <p-button class="ml-2" label="Receive Orders" [raised]="true" [badge]="deliveredCount" iconPos="right" (onClick)="receiveInstances()"></p-button>
  </div>
  <div class="flex justify-content-end">
    <label class="mr-2">Show All</label>
    <p-toggleswitch [(ngModel)]="showAll" (change)="toggleShowAll()" data-testid="showAllToggle" />
  </div>
</div>

<div class="flex align-items-center justify-content-center mt-2">
  <p-button pTooltip="Reset Table" tooltipPosition="top" icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)"></p-button>
  <p-button
    pTooltip="Clear Filter/Sort"
    tooltipPosition="top"
    *ngIf="filtersActive"
    icon="pi pi-filter-slash"
    [raised]="true"
    (click)="clearFilters(dt)"></p-button>
</div>

<div class="mt-1 mb-1">
  <p-accordion value="0">
    <p-accordion-panel value="4">
      <p-accordion-header>Orders Calendar</p-accordion-header>
      <p-accordion-content>
        <app-requester-calendar #requesterCalendar></app-requester-calendar>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>

<ng-container>
  <p-table
    #dt
    class="p-datatable-sm"
    [value]="orders"
    [columns]="cols"
    [paginator]="true"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [first]="skip"
    [rows]="take"
    [totalRecords]="totalCount"
    [filterDelay]="300"
    [lazy]="true"
    [scrollable]="true"
    [scrollHeight]="'60vh'"
    stateStorage="local"
    stateKey="requester-dashboard-table"

    (onLazyLoad)="handleTableEvents($event)">

    <ng-template #header let-columns>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn pReorderableColumn [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
          [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
        </p-columnFilter>
      </th>
      </tr>
    </ng-template>

    <ng-template #body let-order let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngStyle]="col.style">
          <ng-container [ngSwitch]="col.template">
            <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'requester']">
              {{ order.OrderSequence }}
            </a>
            <div *ngSwitchCase="'variant'" style="white-space: normal; overflow-wrap: break-word; word-break: break-word">
              {{ order[col.field] }}
            </div>
            <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
              {{ order[col.field] }}
            </div>
            <span *ngSwitchCase="'boolean'">
              {{ order[col.field] === true ? 'Yes' : 'No' }}
            </span>
            <ng-container *ngSwitchDefault>
              {{ order[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10">No orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
